import { render, staticRenderFns } from "./BasicAsyncSelect.vue?vue&type=template&id=158c9224&scoped=true"
import script from "./BasicAsyncSelect.vue?vue&type=script&lang=js"
export * from "./BasicAsyncSelect.vue?vue&type=script&lang=js"
import style0 from "./BasicAsyncSelect.vue?vue&type=style&index=0&id=158c9224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158c9224",
  null
  
)

export default component.exports